import GeneralCRUDModel, {
  ACTION_TYPES as CRUD_ACTION_TYPES,
} from "../general-crud";
import { computed } from "easy-peasy";

export const ACTION_TYPES = { ...CRUD_ACTION_TYPES };

export const RuleStoreModel = {
  ...GeneralCRUDModel("/masterdata/rules"),
  rules: computed((state) => {
    let obj = {};
    state.data.forEach((item) => (obj[item.description] = item.code));
    return obj;
  }),
};
